<template>
    <button type="button" @click='onClick' :disabled='loading'>
        <span class="text" v-if="loading"><loader /></span>
        <span class="text" v-else>{{text}}</span>
    </button>
</template>

<script>
    import Loader from '../partials/Loader.vue'
    export default {
        name:'Button',
        components:{
            Loader
        },
        props:['text', 'loading'],
        data() {
            return {}
        },
        methods:{
            onClick() {
                this.$emit('on-click')
            }

        }
    }
</script>